<template>
  <div v-observe-visibility="{callback: visibility,once: true}" class="booking-options booking-step js-booking-step" v-show="this.$options._componentTag === this.getCurrentStep" :id="this.$options._componentTag">
    <h1 class="booking-title">{{ optionsTitle }}</h1>
    <div class="booking-steps__wrap">
      <div class="booking-steps__wrap-upper">
        <span class="booking-label">Cleaning Types</span>
        <span class="val-error js-cleaning-error">Please select some cleaning type</span>
        <div class="booking-steps__wrap-upper-btns">
          <div v-for="(item, index) in productsOptions" class="booking-steps__wrap-upper-btns-wrap js-type-tab" :data-id="'CleaningType'+ item.id" :ref="'CleaningType'+ item.id" v-on:click="popupKey=index;activetab=index;changeCleaningType(popupKey, item.name, $event.currentTarget, item.work_duration)" v-bind:class="[ index === savedType ? 'is-active' : '' ]" v-bind:key="index">
            <a class="booking-steps__btn" href="javascript:;">
              {{ item.name }}
              <span>${{prices[index]}}</span>
            </a>
            <span class="booking-steps__wrap-upper-btns-text">{{ item.work_duration }}</span>
          </div>
        </div>
        <!--v-if="productsOptions.length && productsOptions[popupKey].package_informations.length"-->
        <div class="booking-steps__wrap-upper-information">
          <a class="booking-steps__info" href="javascript:;" @click="showQualityPopup = true">
            <SvgIcon class="booking-steps__info-ico" iconName="ico-info-circle"/>
            See what's included</a>
        </div>
        <div class="booking-steps__wrap-bottom">
          <div v-for="(item, index) in productsOptions" class="booking-steps__wrap-bottom-box tabcontent" v-show="activetab === index" v-bind:key="index">
            <span class="booking-label">{{ item.additional_extras_label }}</span>
            <div class="booking-steps__wrap-upper-btns">
              <div v-for="(extra, i) in item.additional_extras" v-show="extra.name" :class="['booking-steps__wrap-upper-btns-wrap js-extras-tabs', extra.included ? 'is-active-included is-active js-is-dis' : '']" :data-slug="extra.name.replace(/ /g,'-')" :data-val="extra.price" :data-name="extra.name" :data-id="'CE'+ index + i" :ref="'CE'+ index + i" @click="selected = i;savedExtra='CE'+ index + i;changeExtraPrice(index, extra.price, $event.currentTarget, extra.name, item.name)" v-bind:key="i">
                <a class="booking-steps__btn" href="javascript:;">
                  <span class="booking-steps__included" v-if="extra.included">included</span>
                  {{ extra.name }}</a>
                <span class="booking-steps__wrap-upper-btns-text" v-if="extra.price">+${{ extra.price }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="booking-side__image booking-location__image">
        <img class="media-item booking-side__image-firefox" :src="imagesPath" alt="animation">
        <div class="anim-holder">
          <div class="anim-container anim-container--02"></div>
        </div>
      </div>
    </div>
    <div class="quality-popup" v-if="showQualityPopup">
      <div class="quality-popup__container">
        <span class="quality-popup-close" @click="showQualityPopup = false"><SvgIcon class="quality-popup__close-ico" iconName="ico-close"/></span>
        <div class="ovelray-quality-popup" v-if="showQualityPopup" @click="showQualityPopup = false"></div>
        <div class="quality-popup__scroll">
          <h1 class="quality-popup__title">Cleaning Quality Checklist</h1>
          <div class="quality-popup__wrap">
            <div class="quality-popup__wrap-left" v-if="productsPopup.popupLeft">
              <div class="quality-popup__wrap-left-boxes">
                <div class="quality-popup__wrap-left-boxes-holder" v-if="productsPopup.popupLeft">
                  <div class="quality-popup__wrap-left-box" v-for="(list, index) in productsPopup.popupLeft" :key="index">
                    <h2 class="quality-popup__wrap-left-title quality-popup__wrap-left-title--first" v-html="list.list_name"></h2>
                    <h3 class="quality-popup__wrap-left-box-title" v-html="list.list_subtitle"></h3>
                    <ul class="quality-popup__wrap-left-box-lists" v-if="list.list_items">
                      <li class="quality-popup__wrap-left-box-list" v-for="(val, i) in list.list_items" :key="i">
                        <span class="quality-popup__wrap-left-box-list-icon">
                          <SvgIcon class="quality-popup__wrap-left-box-list-ico" iconName="ico-check"/>
                        </span>{{ val.item }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="quality-popup__wrap-left-boxes-holder quality-popup__wrap-left-boxes-holder--padding" v-if="productsPopup.popupCenter">
                  <div class="quality-popup__wrap-left-box" v-for="(item, index) in productsPopup.popupCenter" :key="index">
                    <h2 class="quality-popup__wrap-left-title" v-html="item.list_name"></h2>
                    <h3 class="quality-popup__wrap-left-box-title" v-html="item.list_subtitle"></h3>
                    <ul class="quality-popup__wrap-left-box-lists" v-for="(val, i) in item.list_items" :key="i">
                      <li class="quality-popup__wrap-left-box-list">
                        <span class="quality-popup__wrap-left-box-list-icon">
                          <SvgIcon class="quality-popup__wrap-left-box-list-ico" iconName="ico-check"/>
                        </span>{{ val.item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="quality-popup__wrap-right" v-if="productsPopup.popupRight">
              <div class="quality-popup__wrap-left-boxes">
                <div class="quality-popup__wrap-left-boxes-holder">
                  <div class="quality-popup__wrap-left-box" v-for="(item, index) in productsPopup.popupRight" :key="index">
                    <h2 class="quality-popup__wrap-left-title quality-popup__wrap-left-title--right" v-html="item.list_name"></h2>
                    <h3 class="quality-popup__wrap-left-box-title" v-html="item.list_subtitle"></h3>
                    <ul class="quality-popup__wrap-left-box-lists" v-for="(val, i) in item.list_items" :key="i">
                      <li class="quality-popup__wrap-left-box-list">
                        <span class="quality-popup__wrap-left-box-list-icon">
                          <SvgIcon class="quality-popup__wrap-left-box-list-ico" iconName="ico-check"/>
                        </span>{{ val.item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div><!-- .booking-options -->
</template>

<script>
import SvgIcon from '../base/SvgIcon/SvgIcon.vue';
import Global from '../../../js/shared/global';
import {mapGetters} from 'vuex';
import lottieWeb from 'lottie-web';
import locationSearch from '../../../js/site/locationSearch';

export default {
  props: ['productsOptions', 'optionsTitle', 'productsPopup'],
  components: {
    SvgIcon
  },
  data: function() {
    return {
      prices: ['125', '150', '215'],
      showQualityPopup: false,
      hide: true,
      activetab: 0,
      selected: 0,
      popupKey: 0,
      type: {},
      savedType: null,
      savedExtra: null,
      isLoad: true,
      savedExtrasKeys: Global.readCookie('extraPriceTotal') ? Global.readCookie('extraPriceTotal').childrenIds : [],
      imagesPath: process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/2.png'
    };
  },
  computed: {
    ...mapGetters([
      'getCurrentStep',
    ])
  },
  mounted() {
    this.animation();
    locationSearch.initAutocompleteWidget();
  },
  methods: {
    animation() {
      setTimeout(() => {
        const animContainer = document.getElementsByClassName('anim-container--02');
        let animation;
        animContainer.forEach(function(el) {
          animation = process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/Icon2.json';
          const anim = lottieWeb.loadAnimation({
            container: el,
            animType: 'svg',
            loop: true,
            autoplay: true,
            path: animation,
            renderer: 'svg',
            rendererSettings: {
              progressiveLoad: true,
            },
          });
          anim.play();
        });
      }, 500);
    },
    visibility(isVisible) {
      if (!isVisible) {
        return;
      }
      const optionsPrefill = Global.readCookie('extraPriceTotal');
      if (optionsPrefill?.parentId) {
        const el = document.querySelector(`.js-type-tab[data-id="${optionsPrefill.parentId}"]`);
        if (el) {
          el.click();
        }
      }
      if (optionsPrefill?.childrenIds) {
        for (let i = 0; i < optionsPrefill.childrenIds.length; i++) {
          const id = optionsPrefill.childrenIds[i];
          const el = document.querySelector(`.js-extras-tabs[data-id="${id}"]`);
          if (el) {
            el.classList.add('is-active');
          }
        }
      }

      this.isLoad = false;
    },
    chooseTab(num) {
      this.listView = num === 1;
    },
    changeCleaningType(key, name, el, workingHours) {
      const dataId = el.getAttribute('data-id');
      Global.setCookie('activeTypeTab', dataId);
      this.type = {};
      this.savedType = key;
      this.type = {
        'productId': this.$props.productsOptions[key].id,
        'extraPrice': this.$props.productsOptions[key].additional_extras[0]?.price,
        'bedrooms': this.$props.productsOptions[key]?.bedrooms,
        'bathrooms': this.$props.productsOptions[key]?.bathrooms,
        'extrasNames': Global.readCookie('activeExtraTabsNames'),
        'workingHours': workingHours,
      };
      if (this.savedExtra) {
        this.savedExtrasKeys.push(this.savedExtra);
      }

      this.$store.dispatch('setCleaningType', this.type);
      const error = document.querySelector('#BlockStepOptions .js-cleaning-error');
      if (error) {
        error.style.display = 'none';
      }
    },
    changeExtraPrice(key, val, el) {
      const extrasTabs = document.querySelectorAll('.js-extras-tabs');
      if (extrasTabs && !this.isLoad) {
        el.classList.toggle('is-active');
      }

      this.savedExtrasKeys.push(this.savedExtra);
      if (!el.classList.contains('is-active')) {
        val = 0;
        this.savedExtra = null;
      }

      const type = {...this.type};
      type.extraPrice = val;
      this.type = type;
      this.$store.dispatch('setCleaningType', type);
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-options {

  .booking-label {
    font-size: 20px;
    letter-spacing: 4px;
    margin-bottom: 11px;

    @include mq($md) {
      font-size: 14px;
      margin: 0 auto 11px;
      text-align: center;
    }
  }
}

.booking-steps__wrap-upper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 750px;
  width: 100%;

  @include mq($lap-mid) {
    max-width: 650px;
  }

  @include mq($xl) {
    max-width: 100%;
  }
}

.booking-steps__wrap-upper-btns-wrap {
  margin-top: 20px;
  position: relative;

  @include mq($xl) {
    margin: 20px 0 0;
  }

  @include mq($md) {
    margin: 15px 0 0;
  }

  @include mq($xs-phone) {
    width: 100%;
  }
}

.booking-steps__wrap-upper-btns {

  @include mq($xl) {
    justify-content: space-around;
    margin: 0;
  }

  @include mq($md) {
    justify-content: space-between;
  }
}

.booking-steps__btn {
  position: relative;
  flex-direction: column;

  @include mq($xs-phone) {
    min-width: 100%;
  }
}

.booking-steps__wrap-upper-information {
  margin-top: 40px;
}

.booking-steps__wrap-bottom {
  width: 100%;
  margin-top: 40px;

  @include mq($lg) {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.booking-side__image {

  @include mq($xl) {
    max-width: 40%;
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }

  @include mq($lg) {
    max-width: 300px;
    display: initial;

    img {
      margin: auto;
    }
  }
}

//QUALITY POPUP

.quality-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.quality-popup__container {
  box-shadow: 0 15px 40px rgba(51, 80, 153, 0.3);
  border-radius: 30px;
  background-color: $white;
  max-width: 1470px;
  width: 100%;
  padding: 63px 35px 63px 60px;
  position: relative;

  @include mq(1470px) {
    max-width: 95%;
    margin: 0 auto;
  }

  @include mq($xl) {
    padding: 50px 28px;
  }

  @include mq(lg) {
    padding: 50px 20px;
  }
}

.quality-popup__scroll {
  max-height: 70vh;
  overflow: auto;
  @include mq(1024px, min) {
    @include scroll-style($dodger-blue, $white, 0, 0.5vw);
  }

  @include mq(lg) {
    padding-right: 10px;
  }

}

.quality-popup__title {
  font-size: 40px;
  font-family: $font-main;
  font-weight: 700;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.2;
  text-align: center;
  color: $mine-shaft;

  @include mq($lap-large) {
    font-size: 30px;
  }

  @include mq($xl) {
    font-size: 26px;
  }

  @include mq($lg) {
    font-size: 24px;
  }

  @include mq($phone) {
    font-size: 22px;
  }
}

.quality-popup__wrap {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 64px;
  margin-right: 5px;

  @include mq($xl) {
    margin-top: 40px;
  }

  @include mq($lg) {
    margin-top: 20px;
  }

  @include mq(900px) {
    flex-wrap: wrap;
    margin-right: 0;
  }
}

.quality-popup__wrap-left {
  max-width: 876px;
  width: 100%;
  border-right: 2px dashed #dcdfe8;

  @include mq($lap-large) {
    max-width: 60%;
  }
  @include mq($xl) {
    max-width: 65%;
  }

  @include mq(900px) {
    max-width: 100%;
    border-right: none;
    margin-bottom: 20px;
  }
}

.quality-popup__wrap-left-title {
  font-size: 26px;
  font-family: $font-main;
  font-weight: 700;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.2;
  color: $space-cadet;

  @include mq($lap-large) {
    font-size: 24px;
  }

  @include mq($xl) {
    font-size: 22px;
  }

  @include mq($lg) {
    font-size: 20px;
  }

  @include mq($phone) {
    font-size: 18px;
  }

  &--first {
    margin-bottom: 20px;
  }
}

.quality-popup__wrap-left-boxes {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: 42px;

  @include mq($xl) {
    margin-top: 20px;
  }
}

.quality-popup__wrap-left-boxes-holder {
  max-width: 50%;
  width: 100%;
  @include mq($xl) {
    max-width: 48%;
  }

  @include mq($lg) {
    max-width: 45%;
  }

  @include mq(900px) {
    max-width: 50%;
  }

  @include mq($phone) {
    max-width: 100%;
  }
}

.quality-popup__wrap-left-boxes-holder--padding {
  padding-left: 23px;
  padding-top: 5px;

  @include mq($phone) {
    padding-left: 0;
    margin-top: 20px;
  }
}

.quality-popup__wrap-left-box {
  display: flex;
  flex-direction: column;
  margin-top: 62px;

  @include mq($xl) {
    margin-top: 40px;
  }

  @include mq($lg) {
    margin-top: 20px;
  }

  &:first-child {
    margin-top: 0;
  }
}

.quality-popup__wrap-left-box-title {
  font-size: 20px;
  font-family: $font-main;
  font-weight: 700;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.2;
  color: $space-cadet;

  @include mq($lap-large) {
    font-size: 18px;
  }

  @include mq($xl) {
    font-size: 16px;
  }
}

.quality-popup__wrap-left-box-list {
  position: relative;
  font-size: 18px;
  font-family: $font-main;
  font-weight: 500;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.58;
  color: $mine-shaft;
  padding-left: 52px;
  margin-top: 23px;
  max-width: 340px;
  padding-right: 10px;

  @include mq($lap-large) {
    font-size: 16px;
    margin-top: 20px;
  }

  @include mq($xl) {
    font-size: 14px;
  }

  @include mq($lg) {
    padding-left: 45px;
    margin-top: 20px;
  }

  @include mq($md) {
    max-width: 100%;
  }

  @include mq($phone) {
    padding-left: 35px;
    margin-top: 15px;
  }

  &:first-child {
    margin-top: 33px;

    @include mq($xl) {
      margin-top: 20px;
    }
  }
}

.quality-popup__wrap-left-box-list-icon {
  position: absolute;
  top: -2px;
  left: 0;
  width: 31px;
  height: 31px;
  border-radius: 50%;
  background-color: $tree-poppy;

  @include mq($lg) {
    width: 25px;
    height: 25px;
    top: 0;
  }
}

.quality-popup__wrap-left-box-list-ico {
  font-size: 10px;
  height: 10px;
  color: $white;
  @include center;
}

.ovelray-quality-popup {
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}

.quality-popup__wrap-right {
  padding-left: 60px;
  margin-right: auto;

  @include mq($lap-large) {
    padding-left: 40px;
    padding-right: 15px;
  }

  @include mq(900px) {
    max-width: 50%;
    padding-left: 0;
    padding-right: 0;
  }

  @include mq($phone) {
    max-width: 100%;
  }

  .quality-popup__wrap-left-boxes-holder {
    max-width: 100%;
  }

  .quality-popup__wrap-left-boxes {
    @include mq($phone) {
      margin-top: 0;
    }
  }
}

.quality-popup-close {
  color: $mine-shaft;
  font-size: 20px;
  position: absolute;
  top: 24px;
  right: 29px;
  cursor: pointer;
  transition: $dur $ease;

  @include mq($xl) {
    top: 13px;
    right: 20px;
  }

  @include mq($phone) {
    font-size: 18px;
  }

  @include hover {
    color: $tree-poppy;
  }

  /deep/ svg {
    height: 33px;
  }
}

.booking-steps__included {
  font-size: 12px;
  position: absolute;
  top: -20px;
  color: $white;
}

.is-active-included {
  pointer-events: none;
  opacity: 0.7;

  a {
    border: 3px solid $tree-poppy;
    background-color: $white;
    color: $tree-poppy;
  }
}
</style>